import React from 'react';
import {
  BarChartOutlined, NumberOutlined, TableOutlined,
} from '@ant-design/icons';

const Illustration = () => (
  <svg className="illus" viewBox="0 0 96 96" fill="none" aria-hidden="true">
    <rect x="8"  y="20" width="36" height="56" rx="6" fill="#eef2ff" stroke="#c7d6ff" />
    <rect x="50" y="20" width="38" height="26" rx="6" fill="#ecfdf5" stroke="#a7f3d0" />
    <rect x="50" y="50" width="38" height="26" rx="6" fill="#fdf2f8" stroke="#fbcfe8" />
    <path d="M14 60 L20 50 L26 56 L34 42 L40 48"
      stroke="#2451b8" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" />
    <text x="69" y="36" fill="#047857" fontSize="11" fontWeight="700" textAnchor="middle">$2.4M</text>
    <rect x="55" y="56" width="6" height="14" fill="#7c3aed" rx="1" />
    <rect x="63" y="60" width="6" height="10" fill="#7c3aed" rx="1" opacity="0.7" />
    <rect x="71" y="54" width="6" height="16" fill="#7c3aed" rx="1" opacity="0.85" />
    <rect x="79" y="58" width="6" height="12" fill="#7c3aed" rx="1" opacity="0.6" />
  </svg>
);

export default function EmptyLaunchpad({
  onPick,
  title = 'Build your first item',
  lede = 'Pick what to build — a chart, a single-value metric, or a paginated table. You can refine the SQL and design after.',
}) {
  const cards = [
    {
      type: 'chart',
      icon: <BarChartOutlined />,
      h: 'Chart',
      d: 'Visualize data as bars, lines, areas, pies, or scatter plots.',
    },
    {
      type: 'metric',
      icon: <NumberOutlined />,
      h: 'Metric',
      d: 'Show a single big number — totals, averages, counts.',
    },
    {
      type: 'table',
      icon: <TableOutlined />,
      h: 'Table',
      d: 'Render the query result as a paginated table.',
    },
  ];
  return (
    <div className="dx-launchpad">
      <Illustration />
      <h3>{title}</h3>
      <p className="lede">{lede}</p>
      <div className="grid">
        {cards.map((c) => (
          <div
            key={c.type}
            className="cta"
            onClick={() => onPick && onPick(c.type)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => e.key === 'Enter' && onPick && onPick(c.type)}
          >
            <div className="ic">{c.icon}</div>
            <div className="h">{c.h}</div>
            <div className="d">{c.d}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
